module.exports = __webpack_public_path__ + "img/var_02_coin.9c6a231c.png";